module.exports = __webpack_public_path__ + "img/xcx.72bc8393.jpg";